import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
const TeamEmptyState = ({ classes }) => {
  return (
    <div className={classes.root}>
      <img src="/assets/cactus.png" alt="cactus" className={classes.image} />
      <Typography className={classes.title}>
        Learner list is <span className={classes.highlight}>empty</span>
      </Typography>
      <Typography
        className={classes.description}
        dangerouslySetInnerHTML={{
          __html:
            'You can manually add students or <br /> bulk import via .csv file.',
        }}
      />
    </div>
  )
}

export default withStyles(styles)(TeamEmptyState)
